import UrlPrefixes from "../../constants/urlPrefixes";

export default v2Image => {
  return {
    id: v2Image.guid,
    label: v2Image.title ? v2Image.title : v2Image.filename,
    path: `${UrlPrefixes.ATTACHMENT_PREFIX}attachments/${v2Image.guid}`
  };
};
